export default __webpack_public_path__ + "static/media/login-brand-image-6-white.87cb97be.jpg";